// Copyright © 2021 The Things Industries B.V.

export default Object.freeze({
  DEFAULT_PORT: 198,
  DEFAULT_PACKAGE_NAME: 'aws-iot',
})
